import { useIntl } from 'react-intl';
import { IrfMessages as messages } from './index';

import { Loader } from '@designsystem/stories/02-atoms/Loader';
import { Message } from '@designsystem/stories/03-molecules/Message';

interface IrfAlertMessagesProps {
  dataState?: string;
  messageType?: string;
  totalEntrys?: number;
}

export const IrfAlertMessages: React.FC<IrfAlertMessagesProps> = ({
  dataState,
  messageType,
  totalEntrys,
}) => {
  const intl = useIntl();

  return (
    <>
      {dataState && (
        <>
          {dataState === 'utd' && (
            <Message
              type="success"
              title={intl.formatMessage(messages.dataSyncUTD)}
              description={totalEntrys ? `Total ${totalEntrys}` : ''}
            />
          )}
          {dataState === 'ood' && (
            <>
              <Message
                type="warning"
                title={intl.formatMessage(messages.dataSyncOOD)}
              />
              <Loader />
            </>
          )}
          {dataState === 'failed' && (
            <>
              <Message
                type="warning"
                title={intl.formatMessage(messages.dataSyncOOD)}
              />
              <Loader />
            </>
          )}
        </>
      )}
      {messageType && (
        <>
          {messageType === 'selectCollection' && (
            <Message
              type="warning"
              title={intl.formatMessage(messages.no_data_selected)}
            />
          )}

          {messageType === 'saveDatas' && (
            <Message
              type="warning"
              title={intl.formatMessage(messages.saveDatas)}
            />
          )}

          {messageType === 'serverError500' && (
            <Message
              type="warning"
              title={intl.formatMessage(messages.serverError500)}
            />
          )}

          {messageType === 'noPeerReview' && (
            <Message
              type="info"
              title={intl.formatMessage(messages.no_peer_reviewed_message)}
            />
          )}
        </>
      )}
    </>
  );
};
